

import Component from './component';
import createComponentFactory from '../createComponent';
import { TweenMax, Expo } from 'gsap/umd/TweenMax';

const status = {
  SHOWN: 'shown',
  HIDDEN: 'hidden'
};

class PageTop extends Component {

  constructor(element, context, options) {
    super(element, context, options);

    this.scrollObserveContext = new IntersectionObserver((changes) => {
      for (const change of changes) {

       if(!change.isIntersecting) {
         this.show();
       } else {
         this.hide();
       }
      }
    }, {
      rootMargin: '-300px 0px 0px',
      threshold: [0]
    });

    this.scrollObserveContext.observe(document.documentElement);

    this._handleClick = this._handleClick.bind(this);
  }

  _bindEvents() {
    this.element.addEventListener('click', this._handleClick);
  }

  _unbindEvents() {
    this.element.removeEventListener('click', this._handleClick);
  }

  _handleClick(evt) {
    evt.preventDefault();

    TweenMax.to(window, .75, {
      scrollTo: { y: 0, autoKill: false },
      ease: Expo.easeOut
    });
  }

  show() {
    this.element.classList.add('is-shown');
  }

  hide() {
    this.element.classList.remove('is-shown');
  }

  didRegisterComponent() {
    this._bindEvents();
  }

  didUnregisterComponent() {
    this._bindEvents();
  }
}


export default createComponentFactory(PageTop);



// WEBPACK FOOTER //
// ./src/js/app/component/pageTop.js